import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  apiUrl: string = 'https://apisunwire.hdsoftware.mx';
  permisosdisponibles = [
    'DASHBOARD',
    'PROYECTOS',
    'USUARIOS',
  ];
}
